<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 240px;">
        <mat-label>Type</mat-label>
        <mat-select
          class="site-filter"
          [(ngModel)]="dataSource.filter_type"
          matTooltip="Filter by Type"
          name="type">
          <mat-option value="">All Types</mat-option>
          <mat-option [value]="siteType" *ngFor="let siteType of utils.getSiteTypes()">{{siteType}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 240px;">
        <mat-label>Status</mat-label>
        <mat-select
          class="site-filter"
          [(ngModel)]="dataSource.filter_status"
          matTooltip="Filter by Status"
          name="status">
          <mat-option value="">All Active Statuses</mat-option>
          <mat-option *ngFor="let siteStatus of utils.getSiteStatuses()" [value]="siteStatus">{{ siteStatus }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_range">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker dateRangeTitle="Date Range" dateRangePlaceholder="Select Date Range" dateRangeTooltip="Filter by Date Range." [dateRangeInput]="dataSource.date_filter_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="tertiary"
        (click)="onSelectAccounts()">
        {{selectedAccounts.length > 0 ? (selectedAccounts.length + ' Accounts Selected') : 'Select Accounts'}}
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>

    <div class="p-2" *ngIf="dataSource.date_filter_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
